var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepfunctions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/48/Arch_AWS-Step-Functions_48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e7157b",
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37 34h15v-4H37zm16-6H36a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h17a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1M34.5 49.5c0 1.378-1.121 2.5-2.5 2.5a2.503 2.503 0 0 1-2.5-2.5c0-1.378 1.121-2.5 2.5-2.5s2.5 1.122 2.5 2.5M12 38v-3h13v3H12m0-9v-3h13v3zm17.5-14.5c0-1.378 1.121-2.5 2.5-2.5s2.5 1.122 2.5 2.5S33.379 17 32 17a2.503 2.503 0 0 1-2.5-2.5M44 42H20v-2h6a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-6v-2h6a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-6v-2h24v4h2v-5a1 1 0 0 0-1-1H33v-1.121c2-.457 3.5-2.242 3.5-4.379 0-2.481-2.019-4.5-4.5-4.5a4.505 4.505 0 0 0-4.5 4.5c0 2.137 1.5 3.922 3.5 4.379V20H19a1 1 0 0 0-1 1v3h-7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7v2h-7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7v3a1 1 0 0 0 1 1h12v1.121c-2 .457-3.5 2.242-3.5 4.379 0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5c0-2.137-1.5-3.922-3.5-4.379V44h12a1 1 0 0 0 1-1v-5h-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepfunctions);
export default __webpack_public_path__ + "static/media/stepfunctions.d6071f5c8da10d67be1d51a6918ea483.svg";
export { ForwardRef as ReactComponent };